import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import { Order } from '../../types/orders/order';
import { Action } from 'redux';

export class CreateOrder implements LoadingAction {
  readonly type = actions.CREATE_ORDER;
  readonly isLoading = true;

  constructor (public order: Order) {}
}

export class CreateOrderSuccess implements LoadingAction {
  readonly type = actions.CREATE_ORDER_SUCCESS;
  readonly isLoading = false;

  constructor (
    public order: Order,
  ) {}
}

export class CreateOrderError implements ErrorAction {
  readonly type = actions.CREATE_ORDER_ERROR;
  readonly isError = true;

  constructor (public code: string) {}
}

export class UpdateOrder implements LoadingAction {
  readonly type = actions.UPDATE_ORDER;
  readonly isLoading = true;

  constructor (public order: Order) {}
}

export class UpdateOrderSuccess implements LoadingAction {
  readonly type = actions.UPDATE_ORDER_SUCCESS;
  readonly isLoading = false;

  constructor (public order: Order) {}
}

export class UpdateOrderError implements ErrorAction {
  readonly type = actions.UPDATE_ORDER_ERROR;
  readonly isError = true;

  constructor (public code: string) {}
}

export class GetOrders implements LoadingAction {
  readonly type = actions.GET_ORDERS;
  readonly isLoading = true;

  constructor (
    public assetId: string
  ) {}
}

export class GetOrdersSuccess implements LoadingAction {
  readonly type = actions.GET_ORDERS_SUCCESS;
  readonly isLoading = false;

  constructor (
    public orders: Order[],
  ) {}
}

export class GetOrdersError implements ErrorAction {
  readonly type = actions.GET_ORDERS_ERROR;
  readonly isError = true;

  constructor (public code: string) {}
}

export class RemoveOrder implements LoadingAction {
  readonly type = actions.REMOVE_ORDER;
  readonly isLoading = true;

  constructor(
    public assetId: string,
    public orderId: string
  ) {}
}

export class RemoveOrderSuccess implements LoadingAction {
  readonly type = actions.REMOVE_ORDER_SUCCESS;
  readonly isLoading = false;
}

export class RemoveOrderError implements ErrorAction {
  readonly type = actions.REMOVE_ORDER_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class EmptyBasket implements Action {
  readonly type = actions.EMPTY_BASKET;
}

export type OrderActions =
  | CreateOrder
  | CreateOrderSuccess
  | CreateOrderError
  | GetOrders
  | GetOrdersSuccess
  | GetOrdersError
  | UpdateOrder
  | UpdateOrderSuccess
  | UpdateOrderError
  | RemoveOrder
  | RemoveOrderSuccess
  | RemoveOrderError
  | EmptyBasket
;